package team.platforma.aicombo.activity.auth.component.fragment.password_restore

import aicombo.composeapp.generated.resources.Res
import aicombo.composeapp.generated.resources.arrow_left
import aicombo.composeapp.generated.resources.arrow_rigt
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.Icon
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.unit.dp
//import androidx.core.bundle.Bundle
import org.jetbrains.compose.resources.painterResource
import org.koin.compose.koinInject
import team.platforma.aicombo.activity.auth.component.fragment.registration.CreatePasswordFragment
import team.platforma.aicombo.theme.colors.AppColors
import team.platforma.auth_presentable.viewModel.ConfirmEmailViewModel
import team.platforma.extra_nav.component.fragment_component.Fragment
import team.platforma.multiplatform_material_extension.ui.OutlineSmsCodeInputField
import team.platforma.multiplatform_material_extension.ui.buttons.ExpandStrategy
import team.platforma.multiplatform_material_extension.ui.buttons.ExtraFAB

object EnterRestoreCodeFragment : Fragment(
    route = "enter_restore_code_fragment",
    fragmentBox = { componentNavigator, fragmentNavigator, paddingValues ->
        val viewModel = koinInject<ConfirmEmailViewModel>()

        val codeTimer = viewModel.codeRequestTimer.collectAsState().value
        val codeConfirmed = viewModel.emailIsConfirmed.collectAsState().value

        val email = remember { "" }

        Box(modifier = Modifier.fillMaxSize()) {
            Scaffold(modifier = Modifier.fillMaxHeight().widthIn(max = 533.dp)
                .align(Alignment.Center),
                topBar = {
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .background(color = AppColors.bg.base().default)
                            .heightIn(min = 64.dp).clickable {
                                fragmentNavigator.navigateBack()
                            },
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Spacer(modifier = Modifier.width(16.dp))
                        Icon(
                            painter = painterResource(Res.drawable.arrow_left),
                            contentDescription = null,
                            tint = AppColors.text().default,
                            modifier = Modifier.size(24.dp)
                        )
                        Text("Подтверждение")
                        Spacer(modifier = Modifier.width(16.dp))
                    }
                }
            ) { paddingValues ->

                var verificationCode by rememberSaveable { mutableStateOf(viewModel.confirmedCode()) }
                val focusManager = LocalFocusManager.current

                Box(
                    modifier = Modifier.fillMaxSize()
                        .padding(top = paddingValues.calculateTopPadding())
                        .clickable(
                            interactionSource = remember { MutableInteractionSource() },
                            indication = null,
                            onClick = {
                                focusManager.clearFocus()
                            }
                        ),
                    contentAlignment = Alignment.Center
                ) {
                    Box(
                        modifier = Modifier.fillMaxHeight()
                            .padding(horizontal = 16.dp),
                        contentAlignment = Alignment.Center
                    ) {
                        Column(
                            modifier = Modifier.fillMaxSize(),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            Row(modifier = Modifier.fillMaxWidth()) {
                                Text(
                                    text = "Вам было отправлено сообщение с кодом \n" +
                                            "для подтверждения. \n" +
                                            "e-mail: ${email}"
                                )
                            }

                            OutlineSmsCodeInputField(
                                value = verificationCode,
                                onValueChange = { change ->
                                    verificationCode = change
                                    if (change.length == 6 && !codeConfirmed) {
                                        viewModel.confirmPhone(
                                            smsCode = verificationCode,
                                            onSuccess = {
                                                fragmentNavigator.navigate(
                                                    fragment = CreatePasswordFragment
                                                )
                                            },
                                            onFail = { message, code ->

                                            }
                                        )
                                    }
                                },
                                items = 6,
                                itemSize = if (isMobile()) 48.dp else 56.dp,
                                itemSpase = if (isMobile()) 12.dp else 24.dp,
                                validate = {
                                },
                                autoRequestFocus = !codeConfirmed
                            )
                        }
                        if (codeConfirmed) {
                            ExtraFAB(
                                areaModifier = Modifier
                                    .align(Alignment.BottomEnd)
                                    .padding(bottom = paddingValues.calculateBottomPadding()),
                                expanded = false,
                                icon = {
                                    Icon(
                                        painter = painterResource(Res.drawable.arrow_rigt),
                                        contentDescription = null
                                    )
                                },
                                onClick = {
//                                    val dataBundle = Bundle()
//                                    dataBundle.putString("email_key", email)
                                    fragmentNavigator.navigate(EnterRestoreCodeFragment)
                                }
                            )
                        } else {
                            ExtraFAB(
                                areaModifier = Modifier
                                    .align(Alignment.BottomCenter)
                                    .padding(bottom = paddingValues.calculateBottomPadding()),
                                expanded = true,
                                expandStrategy = ExpandStrategy.MaxWidth,
                                icon = {},
                                text = {
                                    if (codeTimer.isCountdown) {
                                        Text("Отправить код повторно можно через: ${codeTimer.timer}")
                                    } else {
                                        Text("Отправить код повторно")
                                    }
                                },
                                onClick = {
                                    viewModel.requestCode(
                                        email = email ?: "",
                                        onSuccess = {},
                                        onFail = {

                                        }
                                    )
                                },
                                enabled = !codeTimer.isCountdown
                            )
                        }
                    }
                }
            }
        }

    }
)

private fun isMobile() = false